import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import useAuth from "./hooks/useAuth";
import { baseUrl } from "./shared/Fetch";

// Import all components (kept as-is)
import Dashboard from "./components/dashboard/Dashboard";
import Sidebar from "./components/dashboard/Sidebar";
import Login from "./components/Login/Login";
import { UserMast } from "./components/userMast/UserMast";
import { Page } from "./components/page";
import { Role } from "./components/role";
import Topbar from "./components/dashboard/Menubar";
import { Projects } from "./components/Projects";
import { TestCases } from "./components/TestCases/TestCases";



function App() {
  const navigate = useNavigate();
  const { hasPermission, pageFeatures } = useAuth();

  const [isAuthenticated, setIsAuthenticated] = useState(() => sessionStorage.getItem("token") !== null);


  const loginData = sessionStorage.getItem("loginData");
  const parsedLoginData = loginData ? JSON.parse(loginData) : null;

  if (isAuthenticated) {
    return (
      <div className="main-container">
        <div className="menubar">
          <Topbar setIsAuthenticated={setIsAuthenticated} />
        </div>
        <div className="cont">
          <div className="sidebar">
            <Sidebar hasPermission={hasPermission} pageFeatures={pageFeatures} />
          </div>
          <div className="main-content">
            <Routes>
              (<Route path="dashboard" element={<Dashboard hasPermission={hasPermission} />} />)
              (<Route path="user" element={<UserMast hasPermission={hasPermission} />} />)
              {/* {hasPermission("Page") && <Route path="Page" element={<Page hasPermission={hasPermission} />} />} */}
              <Route path="page" element={<Page hasPermission={hasPermission} />} />
              <Route path="role" element={<Role hasPermission={hasPermission} />} />
              <Route path="testcases" element={<TestCases hasPermission={hasPermission} />} />
              <Route path="projects" element={<Projects hasPermission={hasPermission} />} />
            </Routes>
          </div>
        </div>
      </div>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
      <Route path="*" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
    </Routes>
  );
}

export default App;
